/**
 * @desc 查询某一角色下的用户列表
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.RoleUserListQueryConditions,
): Promise<defs.StandardReturn<defs.Pager<defs.UserInfoDTO>>> {
  return defHttp.post({
    url: '/web/user/queryRole',
    data,
  });
}

export function mock(
  data: defs.RoleUserListQueryConditions,
): Promise<defs.StandardReturn<defs.Pager<defs.UserInfoDTO>>> {
  return defHttp.post({
    url: '/mock/web/user/queryRole',
    data,
  });
}
